var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-col',{attrs:{"sm":_vm.span.sm,"md":_vm.span.md,"lg":_vm.span.lg}},[_c('div',{staticClass:"data-item"},[_c('div',{staticClass:"data-item-label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('div',[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }